/* eslint-disable react/display-name */
import { forwardRef } from "react";
import { useStore } from "../../stores/store";
import { useParams } from "react-router-dom";
import { Grid, Text } from "@mantine/core";
import theme from "../../stores/theme";
import ResultView from "../app-container-components/result-view";
import { observer } from "mobx-react";
import arc from "../../assets/img/arc.png";

const ExportResultView = observer(
  forwardRef<HTMLDivElement>((props, ref) => {
    const { store } = useStore();
    const { id } = useParams();
    const inputElements = store.GetInputByModule(id ?? "");
    const selectorValue = store.selectedInputs;

    const nonCommentsGroups = inputElements.filter((input) => input.inputConfig?.group !== "Comments");
    const commentsGroups = inputElements.filter((input) => input.inputConfig?.group === "Comments");

    return (
      <div ref={ref} style={{ width: "1000px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center", gap: 6, marginBottom: theme.other?.arc.margins[4] }}>
          <img src={store.GetClientLogoUrl()} alt="client-logo" style={{ height: "65px" }} />
          <img src={arc} alt="logo" />
        </div>
        <div style={{ fontWeight: "bold", fontSize: theme.fontSizes?.sm, marginTop: "4px" }}>Entered Inputs</div>
        <Grid
          style={{
            marginBottom: theme.other?.arc.margins[1],
            marginTop: theme.other?.arc.margins[0],
            marginLeft: theme.other?.arc.margins[0],
            marginRight: theme.other?.arc.margins[0],
            padding: theme.other?.arc.paddings[1],
            border: `1px solid ${theme.colors?.gray?.[3] ?? "#e2e2e2"}`,
          }}
        >
          {nonCommentsGroups.map((input) => (
            <Grid.Col span={4} key={input.id} style={{ paddingTop: 0, paddingBottom: 0 }}>
              <Text span weight="bold" size="sm">
                {input.name} -{" "}
              </Text>
              <Text span size="sm" ml={2}>
                {selectorValue && selectorValue[input.id]}
              </Text>
            </Grid.Col>
          ))}
        </Grid>
        <div style={{ fontWeight: "bold", fontSize: theme.fontSizes?.sm }}>Comments</div>
        <Grid
          style={{
            marginBottom: theme.other?.arc.margins[1],
            marginTop: theme.other?.arc.margins[0],
            marginLeft: theme.other?.arc.margins[0],
            marginRight: theme.other?.arc.margins[0],
            padding: theme.other?.arc.paddings[1],
            border: `1px solid ${theme.colors?.gray?.[3] ?? "#e2e2e2"}`,
          }}
        >
          {commentsGroups.map((input) => (
            <Grid.Col span={4} key={input.id} style={{ paddingTop: 0, paddingBottom: 0 }}>
              <Text span weight="bold" size="sm">
                {input.name} -{" "}
              </Text>
              <Text span size="sm" ml={2}>
                {selectorValue && selectorValue[input.id]}
              </Text>
            </Grid.Col>
          ))}
        </Grid>
        <ResultView />
      </div>
    );
  })
);

export default ExportResultView;
